export default "__VITE_ASSET__5b4ce9cb__"